import greenArrowButton from "../../../images/greenArrowButton.svg";
import "./buttonLearnMore.css";

export const ButtonLearnMore = ({ children }) => {
  return (
    <a href="/#" className="button-wrapper">
      <img src={greenArrowButton} alt="green arrow button" />
      <span>{children}</span>
    </a>
  );
};
